import React from "react";
import { styled } from "@mui/system";
import MUIList from "@mui/material/List";
import { ListProps as ListPropsMUI, ListTypeMap } from "@mui/material/List";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface ListProps extends ListPropsMUI {
  component?: React.ElementType;
}

const ListRoot = styled(MUIList, {
  name: "List",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  background: theme.palette.primary.surfaceDefault
}));

export const List = React.forwardRef<HTMLUListElement, ListProps>(function List(
  props,
  ref
) {
  return <ListRoot {...props} ref={ref} />;
}) as OverridableComponent<ListTypeMap<{}, "ul">>;
